module.exports = __webpack_public_path__ + "static/media/shop.697c8445.png";